import { inventoryApi } from '../api/inventoryApi'

export const deleteCategory = async (categoryId: string) => {
  try {
    const { data } = await inventoryApi.deleteCategory(categoryId)
    return data
  } catch (error) {
    console.error(`Error deleting category: `, error)
    throw error
  }
}
